import axios from "axios";
import { headersProvider } from "../apiHelpers";
import constants from "../constants";

export const getAgreementCategories = () =>
  axios.get(`${constants.apiHost}/agreement-categories`, {
    headers: headersProvider(),
  });

export const getAgreementCategoriesActive = () =>
  axios.get(`${constants.apiHost}/agreement-categories/active`, {
    headers: headersProvider(),
  });

export const createAgreementCategory = ({ name }) =>
  axios.post(
    `${constants.apiHost}/agreement-categories/create`,
    { name },
    {
      headers: headersProvider(),
    },
  );

export const updateAgreementCategory = ({ id, name, isActive }) =>
  axios.put(
    `${constants.apiHost}/agreement-categories/${id}`,
    { name, isActive },
    {
      headers: headersProvider(),
    },
  );

export const deleteAgreementCategory = ({ id }) =>
  axios.delete(`${constants.apiHost}/agreement-categories/${id}`, {
    headers: headersProvider(),
  });
